import { getAuth } from 'firebase/auth';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const STATIC_TOKEN = 'j/w1pkmuJdeL5MslaCM6cISLG/rur+E/Pt9/mHtrdBc=';

interface PlaceSearchResponse {
  place_id: string;
}

export const searchPlace = async (vendorName: string, city: string): Promise<string | null> => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    
    if (!user) {
      throw new Error('No user is currently authenticated');
    }

    const searchText = `${vendorName} ${city}`.trim();
    const headers = {
      'X-Auth-Token': STATIC_TOKEN,
      'search-text': searchText
    };

    console.log('📤 Sending search request:', {
      url: `${API_BASE_URL}/api/places/search`,
      method: 'GET',
      headers,
      searchText,
      vendorName,
      city
    });
    
    const response = await fetch(`${API_BASE_URL}/api/places/search`, {
      method: 'GET',
      headers
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Search place error:', {
        status: response.status,
        statusText: response.statusText,
        errorText,
        headers: Object.fromEntries(response.headers.entries())
      });
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('📥 Search response:', {
      data,
      status: response.status,
      headers: Object.fromEntries(response.headers.entries())
    });

    // Extract placeId from the array response
    if (Array.isArray(data) && data.length > 0 && data[0].place_id) {
      const placeId = data[0].place_id;
      console.log('✅ Found placeId:', placeId);
      return placeId;
    }
    
    console.log('❌ No place ID found in response');
    return null;
  } catch (error) {
    console.error('Error searching place:', error);
    throw error;
  }
};

export const getPlaceDetails = async (placeId: string): Promise<any> => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    
    if (!user) {
      throw new Error('No user is currently authenticated');
    }

    console.log('📤 Sending place details request:', {
      url: `${API_BASE_URL}/api/places/details`,
      method: 'GET',
      placeId,
      fields: 'name,rating,formatted_address,opening_hours,website,geometry,photos,reviews'
    });

    const response = await fetch(`${API_BASE_URL}/api/places/details`, {
      method: 'GET',
      headers: {
        'X-Auth-Token': STATIC_TOKEN,
        'place-id': placeId,
        'fields': 'name,rating,formatted_address,opening_hours,website,geometry,photos,reviews'
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Get place details error:', {
        status: response.status,
        statusText: response.statusText,
        errorText,
        headers: Object.fromEntries(response.headers.entries())
      });
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('📥 Place details response:', {
      status: response.status,
      headers: Object.fromEntries(response.headers.entries()),
      data
    });
    return data;
  } catch (error) {
    console.error('Error fetching place details:', error);
    throw error;
  }
}; 